import { useMemo } from "react";
import { buildProficiencyIconMap } from "../constants";
import { useAppConfig } from "../contexts/AppConfigContext";
import type { LevelIconName } from "../icon";

export const useProficiencyIconMap = (): Record<string, LevelIconName> => {
	const { proficiencyLevels } = useAppConfig();
	return useMemo(
		() => buildProficiencyIconMap(proficiencyLevels),
		[proficiencyLevels],
	);
};
